import { Typography } from 'antd';
import styled from 'styled-components';

export default styled(Typography.Text)`
  font-size: 18px;
  font-weight: 300;
`;
